import { render, staticRenderFns } from "./admin.employees.page.vue?vue&type=template&id=a780ad76&scoped=true&"
import script from "./admin.employees.page.vue?vue&type=script&lang=js&"
export * from "./admin.employees.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.employees.page.vue?vue&type=style&index=0&id=a780ad76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a780ad76",
  null
  
)

export default component.exports